import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const getPublicBundle = gql`
  query GetPublicBundle($input: GetBundle!) {
    getPublicBundle(input: $input) {
      ...PublicBundle
    }
  }

  ${Fragments.bundle.publicBundle}
`;

export const listPublicBundleListings = gql`
  query ListPublicBundleListings($input: ListPublicBundleListingsInput) {
    listPublicBundleListings(input: $input) {
      hasMore
      bundleListings {
        ...PublicBundleListing
      }
    }
  }

  ${Fragments.bundle.publicBundleListing}
`;

export const getPublicBundleListing = gql`
  query GetPublicBundleListing($id: UUID!) {
    getPublicBundleListing(id: $id) {
      ...PublicBundleListing
    }
  }

  ${Fragments.bundle.publicBundleListing}
`;

export const listBundleListingTagOptions = gql`
  query ListBundleListingTagOptions {
    listBundleListingTagOptions {
      ...BundleListingTagOption
    }
  }

  ${Fragments.bundle.bundleListingTagOption}
`;
